exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-promo[data-v-da4e1f48]{background-color:#dee2e6;width:100%;height:300px}.alert-columns[data-v-da4e1f48]{-webkit-columns:auto 2;-moz-columns:auto 2;columns:auto 2}.alert p[data-v-da4e1f48]{font-weight:500;line-height:1rem}.alert button[data-v-da4e1f48]{color:currentColor}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da4e1f48","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./demo/ui-kit/phd/phd-skeleton-component.vue
// module id = 1131
// module chunks = 0